module.exports = __webpack_public_path__ + "static/media/dashboard-home.fcca9773.png";